import {_get} from "@api/services/httpService";
import {NEXTORE_URL} from "@api/services/nextore/index";

const CENTER_URL = '/centers';

export const getCenters = ()=> _get(`${NEXTORE_URL}${CENTER_URL}`)
